export enum SharedMemoryChangesType {
    REQUEST_STATUS = 'request_status'
}

export type SharedMemoryChangesContent = {
    oldValue: string
    newValue: string
}